import { STATUSES } from "@/constants.js";

const initState = () => ({
  showOptions: false,
  showNewBid: false,
  tabStringOptions: "tab-1",
  errdesc: "",
  alerts: [],
  uid: 0,
  loading: 0,
  showNewYearAction: false,
  redirect: {
    status: false,
    message: "",
    url: "",
  },
  showContact: false,
  // Статусы заявок
  statuses: {
    ...STATUSES,
    ...{
      // желтые
      Confirm: {
        label: "Проверка юридического лица",
        bgColor: "#FAE6AA",
        textColor: "#B79310",
      },
      AccountReserved: {
        label: "Ожидание документов от клиента",
        bgColor: "#FAE6AA",
        textColor: "#B79310",
      },
      AccountReserving: {
        label: "Резервация счёта",
        bgColor: "#FAE6AA",
        textColor: "#B79310",
      },
      ProcessingDocs: {
        label: "Проверка юридического лица",
        bgColor: "#FAE6AA",
        textColor: "#B79310",
      },
      CompleteRegWithoutOgrn: {
        label: "Ожидание выписки ЕГРЮЛ",
        bgColor: "#FAE6AA",
        textColor: "#B79310",
      },
      EgrulPerform: {
        label: "Обработка выписки ЕГРЮЛ",
        bgColor: "#FAE6AA",
        textColor: "#B79310",
      },
      wait_start_web_service: {
        label: "Ожидание начала проверки ФНС",
        bgColor: "#FAE6AA",
        textColor: "#B79310",
      },
      accopenman_create: {
        label: "Создание ручного открытия счёта",
        bgColor: "#FAE6AA",
        textColor: "#B79310",
      },
      "card.wait": {
        label: "Ожидание банковской карточки",
        bgColor: "#FAE6AA",
        textColor: "#B79310",
      },
      "doc.wait": {
        label: "Ожидание проверки документов по встрече",
        bgColor: "#FAE6AA",
        textColor: "#B79310",
      },
      "okved.wait": {
        label: "Ожидание согласования окведов",
        bgColor: "#FAE6AA",
        textColor: "#B79310",
      },
      "pass.wait": {
        label: "Ожидание проверки паспортов",
        bgColor: "#FAE6AA",
        textColor: "#B79310",
      },
      "ul.wait": {
        label: "Ожидание проверки выписки ЮЛ",
        bgColor: "#FAE6AA",
        textColor: "#B79310",
      },
      "egrul.wait": {
        label: "Ожидание проверки выписки ЕГРЮЛ",
        bgColor: "#FAE6AA",
        textColor: "#B79310",
      },
      // зеленые
      ReadyForMeeting: {
        label: "Готов к встрече",
        bgColor: "#D4F296",
        textColor: "#5E8C00",
      },
      SuccessOpenAccount: {
        label: "Счёт открыт",
        bgColor: "#D4F296",
        textColor: "#5E8C00",
      },
      "account.open": {
        label: "Счёт открыт",
        bgColor: "#D4F296",
        textColor: "#5E8C00",
      },
      // красные
      RefuseOpenAccount: {
        label: "Отказ юридическому лицу",
        bgColor: "#F9C1BD",
        textColor: "#A61D1D",
      },
      RefusePrivatePerson: {
        label: "Отказ физическому лицу",
        bgColor: "#F9C1BD",
        textColor: "#A61D1D",
      },
      "checklist.decline": {
        label: "Отказ по результатам встречи",
        bgColor: "#F9C1BD",
        textColor: "#A61D1D",
      },
      "fl.decline": {
        label: "Отказ физическому лицу",
        bgColor: "#F9C1BD",
        textColor: "#A61D1D",
      },
      "okved.decline": {
        label: "Отказ по ОКВЭДам",
        bgColor: "#F9C1BD",
        textColor: "#A61D1D",
      },
      "ul.decline": {
        label: "Отказ юридическому лицу",
        bgColor: "#F9C1BD",
        textColor: "#A61D1D",
      },
      "wb.decline": {
        label: "Отказ по результатам проверки ФНС",
        bgColor: "#F9C1BD",
        textColor: "#A61D1D",
      },
      // для статусов доков
      reupload: {
        label: "Необходимо загрузить файлы заново",
        bgColor: "#F9C1BD",
        textColor: "#A61D1D",
      },
      approved: {
        label: "Проверены и подтверждены",
        bgColor: "#D4F296",
        textColor: "#5E8C00",
      },
      wait_upload: {
        label: "Ожидание загрузки",
        bgColor: "#FAE6AA",
        textColor: "#B79310",
      },
      complete: {
        label: "Завершен",
        bgColor: "#D4F296",
        textColor: "#5E8C00",
      },
      pending: {
        label: "В работе",
        bgColor: "#FAE6AA",
        textColor: "#B79310",
      },
      in_work: {
        label: "В работе",
        bgColor: "#FAE6AA",
        textColor: "#B79310",
      },
      // для обработки документов App
      completed: {
        label: "Завершен",
        bgColor: "#D4F296",
        textColor: "#5E8C00",
      },
      created: {
        label: "Создано",
        bgColor: "#FAE6AA",
        textColor: "#B79310",
      },
    },
  },
});

export default {
  namespaced: true,
  state: initState,
  getters: {
    errdesc: (state) => state.errdesc,
    alerts: (state) => state.alerts,
    loading: (state) => !!state.loading,
    redirect: (state) => state.redirect,
  },
  mutations: {
    showContactPopup: (state, value) => {
      state.showContact = value;
    },
    reset: (state) => {
      const initialState = initState();
      // Сохраняем ошибки при ресете
      const newState = { ...initialState, errdesc: state.errdesc, alerts: state.alerts };
      Object.keys(newState).forEach((key) => (state[key] = newState[key]));
    },
    toggleOptions: (state) => {
      state.showOptions = !state.showOptions;
    },
    toggleOptions2: (state, value) => {
      if (!value) state.tabStringOptions = "tab-1";
      state.showOptions = value;
    },
    showNewBidModal: (state, value) => {
      state.showNewBid = value;
    },
    tabShowOptions(state, value) {
      state.tabStringOptions = value;
    },
    toogleNewYear: (state, value) => (state.showNewYearAction = value),

    setErrdesc: (state, value) => (state.errdesc = value),
    setRedirect(state, { url, message }) {
      state.redirect = { url, message, status: true };
    },

    clearRedirect(state) {
      state.redirect = {
        status: false,
        message: "",
        url: "",
      };
    },
    addAlert(state, { type, msg }) {
      state.uid++;
      state.alerts.push({ type, msg, id: state.uid });
    },

    removeAlert(state, id) {
      let i = state.alerts.filter((el) => el.uid === id);
      state.alerts.splice(i, 1);
    },
    startLoading: (state) => ++state.loading,
    stopLoading: (state) => --state.loading,
  },
  actions: {
    addAlert({ commit }, { type, msg }) {
      commit("addAlert", { type, msg });

      setTimeout(() => {
        commit("removeAlert");
      }, 3000);
    },
    // автоудаление через 3 сек
    clearErrdesc({ commit, state: { errdesc } }) {
      if (errdesc.length > 0) {
        commit("setErrdesc", "");
      }
    },
  },
};
